import { render } from "./Project3View.vue?vue&type=template&id=8bbe9a4c&scoped=true&ts=true"
import script from "./Project3View.vue?vue&type=script&lang=ts"
export * from "./Project3View.vue?vue&type=script&lang=ts"

import "./Project3View.vue?vue&type=style&index=0&id=8bbe9a4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbe9a4c"]])

export default __exports__